import Building from "@modules/navigator/Building/Building.js";
import PriceList from "@modules/navigator/views/PriceList/PriceList.js";
import Floor from "./Floor/Floor.js";
import Space from "./Space/Space.js";
import App from "../../templates/src/App/App.js";
import Header from "@templates/Header/Header.js";
import NavigatorRouter from "@modules/navigator/Navigator.router.js";
import BannerParallax from "@templates/Components/BannerParallax/BannerParallax.js";
import {isObject} from "lodash";

const Navigator = {
    isTablet: window.innerWidth < 1024,
    isMobile: window.innerWidth < 450,
    view: 'building',
    height: null,
    defaultHeight: null,
    scene: null,

    init() {
        this.el = $('[module="Navigator"]');
        if (!this.el.length) return;

        this.scene = this.el.attr('scene');

        Building.init();
        Floor.init(this.el);
        Space.init(this.el);
        PriceList.init();
        this.Router.init();
        NavigatorRouter.init();
        this.resize();
    },

    Router: {
        path: null,

        route: {
            floor: null,
            flat: null,
        },

        init() {
            this.path = window.location.pathname;

            this.prepare();
            this.controller();
        },

        prepare() {
            // Create a URL object to extract the pathname
            const urlObject = new URL(window.location);

            // Define a regex pattern to capture floor number and optional apartment details
            // const pattern = /^\/(\d+)-podlazie(?:\/(byt-[a-zA-Z]+)_(\d+)_(\d+))?$/;
            const pattern = /^\/(\d+)-podlazie(?:\/([\w-]+-(\d+[a-zA-Z]+)))?$/;

            // Match the URL pathname after "/byty"
            const match = urlObject.pathname.replace('/'+navigatorBaseUrl, '').match(pattern);

            // Check if the URL pathname matches the pattern and capture groups
            if (!match) {
                console.log('The URL does not match the dynamic route pattern.');
                return;
            }

             // Capture group 1: dynamic floor number (e.g., "1", "2", "12")
            this.route.floor = Number(match[1]);

            if (match[2]) {
                // Create the flat name by formatting apartment details
                this.route.flat = match[2].replace("byt-", "");
                this.route.flat = this.route.flat.replace("nebytovy-priestor-", "");
                this.route.flat = this.route.flat.replace("apartman-", "");
            }
        },

        controller() {
            let isModified = false;

            if (this.route.floor) {
                if (!this.isFloorExist(this.route.floor)) {
                    console.log("Invalid floor, removing from URL");
                    this.removeFloorFromUrl();
                    isModified = true;
                }
            }

            if (this.route.flat && !isModified) { // Only check the flat if the floor was valid
                if (!this.isAreaExist(this.route.flat)) {
                    console.log("Invalid flat, removing from URL");
                    this.removeAreaFromUrl();
                }
            }
        },

        isFloorExist(number) {
            return Boolean(Building.data.floors[number]);
        },

        isAreaExist(name) {
            return Boolean(Building.data.flats[name]);
        },

        removeFloorFromUrl() {
            const newUrl = this.path.replace(/\/\d+-podlazie(\/.*)?$/, '');

            this.route.floor = null;
            this.route.flat = null;

            this.updateUrl(newUrl);
        },

        removeAreaFromUrl() {
            const newUrl = this.path.replace(/\/([\w-]+-(\d+[a-zA-Z]+))$/, '');

            this.route.flat = null;

            this.updateUrl(newUrl);
        },

        updateUrl(newPath, reload = false) {
            const fullUrl = `${window.location.origin}${newPath}`;

            if (reload) {
                window.location.href = fullUrl;
            } else {
                window.history.replaceState(null, '', fullUrl);
            }
        }
    },

    formatPrice(price) {
        return new Intl.NumberFormat('sk-SK', {
            style: 'currency',
            currency: 'EUR'
        }).format(price);
    },

    debounce(func, delay) {
        let debounceTimer;
        return function (...args) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(this, args), delay);
        };
    },

    setHeight() {
        if (this.debug) console.log('setHeight', this.view, Floor.height)
        switch (this.view) {
            case 'pricelist':
                Header.toggleSubmenu(false);
                break;
            case 'building':
                this.el.removeAttr('style');
                Floor.el.removeAttr('style');
                Space.el.removeAttr('style');
                BannerParallax.resize();
                break;
            case 'floor':
                this.height = Math.max(this.defaultHeight, Floor.height);
                this.el.css({minHeight: this.height});
                Floor.el.css({height: this.height}).removeClass('disabled');
                Header.toggleSubmenu(!isObject(NavigatorRouter.state.floor));
                break;
            case 'space':
                this.height = Math.max(this.defaultHeight, Floor.height, Space.height);
                this.el.css({minHeight: this.height});
                Floor.el.css({height: this.height}).addClass('disabled');
                Space.el.css({minHeight: this.height});
                Header.toggleSubmenu(!isObject(NavigatorRouter.state.floor));
                break;
        }
    },

    resize() {
        if (!this.el.length) return;

        const css = getComputedStyle($('body')[0]);
        const footerHeight = parseFloat(css.getPropertyValue('--footer-height'));
        this.defaultHeight = window.innerHeight - footerHeight;

        Floor.resize();
        Space.resize();
        setTimeout(() => {
            this.setHeight();
        }, 1)
    },

    isPriceListPage() {
        return this.view === 'pricelist';
    }
}

export default Navigator;